export default __webpack_public_path__ + "static/about-8595b0967ebfa4037f25415d9b6ae4ca.png";